import { Modal, Button } from "react-bootstrap";
const OrderInstructions = ({ order, show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="!text-base font-medium">
          Provider Instructions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="!text-sm">
        {order ? (
          <div>
            {/* Display svc_order_line details if available */}
            {order.order_ship_instructions && (
              <>
                <h5>Order# {order.order_id}</h5>
                <p>{order.order_ship_instructions}</p>
              </>
            )}
          </div>
        ) : (
          <p>No order details available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          className="w-full !rounded-md !max-w-24 !text-sm text-black !bg-white h-[43px] !border-[#E9E9E9]"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderInstructions;
